var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 61.441,
    viewBox: "0 0 62 61.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_orange",
    transform: "translate(-646.476 -625.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11506",
    "data-name": "Path 11506",
    d: "M646.716,701.525c.2,17.6,12.611,24.79,25.193,16.825,3.723-2.338,6.031-1.24,13.447-1.588.433,6.724-12.091,2.885-12.178,8.773-.058,3.059,6.465,4.386,14.343.981,7.734-3.347,8.744-10.591,14.458-10.619-11.716,34.947-59.274,20.634-55.263-14.372Z",
    transform: "translate(0 -48.666)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11507",
    "data-name": "Path 11507",
    d: "M658.1,668.154c-7.762-8.224-7.907-23.692.462-32.436,8.34-8.8,22.856-13.044,35.639-6.926-22.682-4.3-44.412,17.373-36.1,39.363Z",
    transform: "translate(-3.734)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11508",
    "data-name": "Path 11508",
    d: "M716.866,640.9c32.667-14.776,50.039,27.3,25.02,47.9,19.306-21.3,3.087-52.724-25.02-47.9Z",
    transform: "translate(-45.303 -7.667)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11509",
    "data-name": "Path 11509",
    d: "M725.114,668.925a4.834,4.834,0,1,0-4.848-4.818,4.828,4.828,0,0,0,4.848,4.818Z",
    transform: "translate(-47.491 -21.463)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11510",
    "data-name": "Path 11510",
    d: "M713.381,708.622c-3.982-11.889-1.3-16.969,6.117-17.056,7.389.087,10.1,5.167,6.09,17.056-.058-4.762.289-11.139-6.09-11.139s-6.059,6.349-6.117,11.139Z",
    transform: "translate(-41.877 -42.257)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11511",
    "data-name": "Path 11511",
    d: "M682.638,692.631a3.65,3.65,0,1,0-3.665-3.665,3.664,3.664,0,0,0,3.665,3.665Z",
    transform: "translate(-20.915 -38.243)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11512",
    "data-name": "Path 11512",
    d: "M673.774,722.654c-3.03-9-.981-12.841,4.617-12.871,5.6.03,7.618,3.867,4.617,12.871-.058-3.608.2-8.427-4.617-8.427s-4.559,4.818-4.617,8.427Z",
    transform: "translate(-16.668 -53.981)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11513",
    "data-name": "Path 11513",
    d: "M774.281,689.57a3.65,3.65,0,1,0-3.666-3.664,3.665,3.665,0,0,0,3.666,3.664Z",
    transform: "translate(-79.897 -36.274)",
    fill: "#df7467"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11514",
    "data-name": "Path 11514",
    d: "M774.689,715.727c2.424-4.761.982-8.974-4.617-9-5.6.029-8.224,4.617-4.156,14.573-.894-4.761-1.1-10.042,4.156-10.129,1.962-.029,4.473.924,4.617,4.56Z",
    transform: "translate(-75.601 -52.012)",
    fill: "#df7467"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93609fd40f5d126a1da8c6dbae0d978b.svg";
export { ForwardRef as ReactComponent };